/* eslint-disable */
import React, { useState } from 'react';
import axios from 'axios';

export default function App() {

	const [showStatus, setShowStatus] = useState(false);
	const [links, setLinks] = useState(window.lhfs.links);

	const [updatedLinks, setUpdatedLinks] = useState(window.lhfs.links.map(({ modifiedBy, ...item}) => item));

	const updateLink = (code, e) => {
		const url = e.target.value;
		setUpdatedLinks(
			updatedLinks.map((item) => {
				if (item.code === code) {
					return { ...item, url };
				} else {
					return item;
				}
			})
		);
	};

	const handleSave = (event) => {
		event.preventDefault();

		updatedLinks.forEach((link, index) => {
			//post only links that the url was changed
			if (link.url !== links[index].url) {
				axios.post('/externallink', link)
					.then(function (response) {
						//console.log(response);
						setShowStatus(true);
						setTimeout(() => setShowStatus(false), 3000);
					})
					.catch(function (error) {
						console.log(error);
					})
            }

		});

		//window.location.reload(false);
	}

	const handleCancel = (event) => {
		event.preventDefault();
		window.location.reload(false);
    }

	const linkItems = links.map((link, index) => (
		<div className="row" key={index}>
			<div className="col-lg-4 col-xl-3">
				<div className="form-group">
					<label htmlFor={link.code}>{link.code}</label>
				</div>
			</div>
			<div className="col-lg-8 col-xl-9">
				<div className="form-group">
					<input type="text" defaultValue={link.url} name={link.code} className="form-control" onChange={(e) => updateLink(link.code, e)} />
				</div>
			</div>
		</div>
	));

	return (
		<div>
			<h1>External Links</h1>
			{linkItems}
			<form>
				<div className="btn-container">
					<input type="submit" value="Save" className="btn primary-btn" onClick={handleSave} />
					<button className="btn secondary-btn" onClick={handleCancel}>Cancel</button>
				</div>
			</form>
			{showStatus && <div className="status">Links Saved</div>}
		</div>
	);
}